<template>
  <div class="user-config">
    <div class="user-config__item">
      <div class="f fs gap8 mb24">
        <svg height="24" width="24">
          <use xlink:href="/icons/sprite.svg#i-eye"></use>
        </svg>
        <h2>{{ t('viewmodel') }}</h2>
      </div>
      <div class="card card-dark">
        <div class="card-item">
          <p class="card-item-title">FOV</p>
          <span class="card-item-value">{{ info.viewmodel?.viewmodel_fov }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('offset') + ' X' }}</p>
          <span class="card-item-value">{{ info.viewmodel?.viewmodel_offset_x }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('offset') + ' Y' }}</p>
          <span class="card-item-value">{{ info.viewmodel?.viewmodel_offset_y }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('offset') + ' Z' }}</p>
          <span class="card-item-value">{{ info.viewmodel?.viewmodel_offset_z }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">Presetpos</p>
          <span class="card-item-value">{{ info.viewmodel?.viewmodel_preset_pos }}</span>
        </div>
      </div>
    </div>
    <div class="user-config__item">
      <div class="f fs gap8 mb24">
        <svg height="24" width="24">
          <use xlink:href="/icons/sprite.svg#i-mouse"></use>
        </svg>
        <h2>{{ t('mouse') }}</h2>
      </div>
      <div class="card card-dark">
        <div class="card-item">
          <p class="card-item-title">DPI</p>
          <span class="card-item-value">{{ info.mouse?.mouse_dpi }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('sensitivity') }}</p>
          <span class="card-item-value">{{ info.mouse?.mouse_sensitivity }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">eDPI</p>
          <span class="card-item-value">{{ info.mouse?.mouse_edpi }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">Hz</p>
          <span class="card-item-value">{{ info.mouse?.mouse_hz }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('zoom_sensitivity') }}</p>
          <span class="card-item-value">{{ info.mouse?.mouse_zoom_sensitivity }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('windows_sensitivity') }}</p>
          <span class="card-item-value">{{ info.mouse?.mouse_windows_sensitivity }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="user-config">
    <div class="user-config__item">
      <div class="f fs gap8 mb24">
        <svg height="24" width="24">
          <use xlink:href="/icons/sprite.svg#i-crosshair"></use>
        </svg>
        <h2>{{ t('crosshair') }}</h2>
      </div>
      <div class="card card-dark">
        <CrosshairSlider :crosshair="info.crosshair" class="slider" />

        <div class="card-item">
          <p class="card-item-title">{{ t('style') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_style }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('follow_recoil') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_follow_recoil }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('dot') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_dot }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('length') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_length }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('thickness') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_thickness }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('gap') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_gap }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('outline') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_outline }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('color') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_color }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('color_translates.red') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_red }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('color_translates.green') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_green }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('alpha') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_alpha }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('t_style') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_t_style }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('sniper_width') }}</p>
          <span class="card-item-value">{{ info.crosshair?.crosshair_sniper_width }}</span>
        </div>
        <div class="card-item">
          <p class="card-item-title">{{ t('deployed_weapon_gap') }}</p>
          <span class="card-item-value">{{
              info.crosshair?.crosshair_deployed_weapon_gap
            }}</span>
        </div>
      </div>
    </div>
    <div class="user-config__item">
      <div class="f fs gap8 mb24">
        <svg height="24" width="24">
          <use xlink:href="/icons/sprite.svg#i-settings"></use>
        </svg>
        <h2>{{ t('full_config') }}</h2>
      </div>
      <div class="card card-dark not-grid">
        <div>
          <p class="not-grid-title">{{ t('crosshair') }}</p>
          <div class="fake-input f">
            <p class="p8">
              {{ info.crosshair?.crosshair_in_game_config }}
            </p>
            <button
                class="btn btn-transparent fw400 gap4 primary"
                @click="copy(info.crosshair?.crosshair_in_game_config || '')"
            >
              <svg height="20" width="20">
                <use xlink:href="/icons/sprite.svg#i-copy"></use>
              </svg>
              {{ t('copy').toUpperCase() }}
            </button>
          </div>
        </div>
        <div>
          <p class="not-grid-title">{{ t('viewmodel') }}</p>
          <div class="fake-input f">
            <p class="p8">
              {{ info.viewmodel?.viewmodel_in_game_config }}
            </p>
            <button
                class="btn btn-transparent fw400 gap4 primary"
                @click="copy(info.viewmodel?.viewmodel_in_game_config || '')"
            >
              <svg height="20" width="20">
                <use xlink:href="/icons/sprite.svg#i-copy"></use>
              </svg>
              {{ t('copy').toUpperCase() }}
            </button>
          </div>
        </div>


        <button
            v-if="info.config_file"
            class="btn btn-primary btn-violet mra"
            @click="downloadFile"
        >
          <svg height="24" width="24">
            <use xlink:href="/icons/sprite.svg#i-download"></use>
          </svg>
          {{ t('download_full_config') }}
        </button>

      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {EventBus} from '~/composables/bus';
import {ProPlayerWithItems} from "~/graphql/generated/schema-types";
import CrosshairSlider from "~/components/Pages/ProPlayer/Components/CrosshairSlider.vue";

const props = defineProps<{
  info: ProPlayerWithItems,
}>()

const {t} = useI18n()
const copy = (text: string) => {
  navigator.clipboard.writeText(text)
  EventBus.$emit('notify', {
    success: true,
    msg: t('notify.copied'),
  })
}

const downloadFile = () => {
  if (props.info.config_file) {
    const link = document.createElement('a');
    link.href = props.info.config_file;
    link.download = 'config_file.txt'; // Или другое название файла
    link.click();
  }
}
</script>

<style lang="scss" scoped>


.user-config {
  display: flex;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;

    .user-config__item {
      width: 100%;
    }
  }

  &__item {
    width: 50%;
    display: flex;
    flex-direction: column;

    .card {
      height: 100%;
      display: grid;
      gap: 0 32px;
      grid-template-columns: repeat(auto-fill, minmax(125px, 1fr));
      padding: 8px 24px;
      position: relative;

      .slider {
        grid-column: 1 / -1; // Элемент займет всю ширину
      }

      &.not-grid {
        display: flex;
        flex-direction: column;
        gap: 40px;
        height: 100%;
        padding: 24px;

        .fake-input {
          border-radius: 8px;
          padding-left: 8px;
          background: var(--surfaces-high-container);
          color: var(--surfaces-on-surface-variable);
          font-size: 14px;
          line-height: 28px;
        }

        .not-grid-title {
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          margin-bottom: 12px;
        }

        &:after {
          content: none;
        }
      }

      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 8px;
        width: 100%;
        height: 5px;
        background: var(--surfaces-low-container);
      }

      &-item {
        padding: 16px 0;
        border-bottom: 1px solid var(--surfaces-outline);

        .card-item-title {
          font-size: 1.6rem;
          font-weight: 600;
          color: var(--surfaces-on-surface-variable);
          margin-bottom: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .card-item-value {
          font-size: 1.6rem;
          color: var(--accent-on-accent-secondary);
          font-weight: 600;
        }
      }
    }
  }
}
</style>
